"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVirtualizedSelect = _interopRequireDefault(require("react-virtualized-select"));

var _SelectWrapper = _interopRequireDefault(require("@cimpress/react-components/lib/SelectWrapper"));

var _reactComponents = require("@cimpress/react-components");

var _fi = require("./apis/fi.api");

var _cimpressCustomizr = require("cimpress-customizr");

require("../styles/FulfillerSelect.css");

var _i18n = require("./i18n");

var _reactI18next = require("react-i18next");

var _consts = require("./utils/consts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Spinner = _reactComponents.shapes.Spinner;

var FulfillerMultiSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FulfillerMultiSelect, _React$Component);

  function FulfillerMultiSelect(props) {
    var _this;

    _classCallCheck(this, FulfillerMultiSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FulfillerMultiSelect).call(this, props));
    _this.fulfillerMap = {};
    (props.fulfillers || []).forEach(function (f) {
      return _this.fulfillerMap[f.fulfillerId] = f;
    });
    _this.state = {
      fulfillers: undefined,
      selectedFulfillerIds: props.selectedFulfillerIds || [],
      recentFulfillerIds: [],
      fetchingFulfillers: true
    };
    _this.customizrClient = new _cimpressCustomizr.CustomizrClient({
      resource: 'https://trdlnk.cimpress.io'
    });
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.fulfillerOptionGroupLabelOptionRenderer = _this.fulfillerOptionGroupLabelOptionRenderer.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.fulfillerSingleOptionRenderer = _this.fulfillerSingleOptionRenderer.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.fulfillerValueRenderer = _this.fulfillerValueRenderer.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.fulfillerWarningMessageOptionRenderer = _this.fulfillerWarningMessageOptionRenderer.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.fulfillerSpinnerOptionRenderer = _this.fulfillerSpinnerOptionRenderer.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onSelectedFulfillerChanged = _this.onSelectedFulfillerChanged.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.mapFulfillerIdsToFulfillers = _this.mapFulfillerIdsToFulfillers.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(FulfillerMultiSelect, [{
    key: "fetchFulfillers",
    value: function fetchFulfillers(accessToken) {
      var _this2 = this;

      this.setState({
        fetchingFulfillers: true
      });
      return (0, _fi.getFulfillers)(accessToken, this.props.env, {
        noCache: true
      }).then(function (fulfillers) {
        fulfillers.forEach(function (f) {
          return _this2.fulfillerMap[f.fulfillerId] = f;
        });

        _this2.setState({
          fulfillers: fulfillers.sort(function (a, b) {
            return a.name.localeCompare(b.name);
          }),
          fetchingFulfillers: false
        });
      }).catch(function (e) {
        _this2.setState({
          fulfillers: [{
            fulfillerId: '-1',
            internalFulfillerId: -1,
            name: e.message || e.Message
          }],
          fetchingFulfillers: false
        });
      });
    }
  }, {
    key: "refreshComponentData",
    value: function refreshComponentData() {
      var _this3 = this;

      return Promise.all([!this.props.fulfillers ? this.fetchFulfillers(this.props.accessToken) : Promise.resolve(), this.getRecentFulfillerIds()]).then(function (results) {
        if (!results[1]) {
          return;
        }

        var _results$ = results[1],
            recentFulfillerIds = _results$.recentFulfillerIds,
            recentFulfillerIdsMulti = _results$.recentFulfillerIdsMulti;
        var fulfillerIdsToSelect = [];

        if (_this3.props.selectedFulfillerIds) {
          fulfillerIdsToSelect = _this3.props.selectedFulfillerIds;
        } else if (recentFulfillerIds.length > 0 && _this3.props.autoSelectMostRecent) {
          fulfillerIdsToSelect = _this3.props.multi ? recentFulfillerIdsMulti : recentFulfillerIds.slice(0, 1);
        }

        var selectedFulfillerIds = fulfillerIdsToSelect.map(function (fulfillerId) {
          return _this3.fulfillerMap[fulfillerId] && _this3.fulfillerMap[fulfillerId].fulfillerId;
        }).filter(function (fulfillerId) {
          return fulfillerId;
        });

        _this3.setState({
          recentFulfillerIds: recentFulfillerIds,
          selectedFulfillerIds: selectedFulfillerIds
        }, function () {
          if (_this3.state.selectedFulfillerIds.length > 0 || _this3.props.multi) {
            var updateCustomizrSettings = !!_this3.props.selectedFulfillerIds;

            _this3.onSelectedFulfillerChanged(_this3.state.selectedFulfillerIds, updateCustomizrSettings);
          }
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.accessToken !== this.props.accessToken || prevProps.env !== this.props.env) {
        this.refreshComponentData();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.accessToken) {
        return;
      }

      this.refreshComponentData();
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      if (!e) {
        return;
      }

      var fulfillerIds = this.props.multi ? e.map(function (f) {
        return f.fulfiller.fulfillerId;
      }) : [e.fulfiller.fulfillerId];
      this.setState({
        selectedFulfillerIds: fulfillerIds
      });
      this.onSelectedFulfillerChanged(fulfillerIds);
    }
  }, {
    key: "onSelectedFulfillerChanged",
    value: function onSelectedFulfillerChanged(fulfillerIds) {
      var updateCustomizrSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (this.props.onChange) {
        this.props.onChange(this.mapFulfillerIdsToFulfillers(fulfillerIds));
      }

      if (updateCustomizrSettings) {
        this.updateRecentFulfillerIds(fulfillerIds);
      }
    }
  }, {
    key: "getRecentFulfillerIds",
    value: function () {
      var _getRecentFulfillerIds = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var settings;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.props.accessToken) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.customizrClient.getSettings(this.props.accessToken);

              case 3:
                settings = _context.sent;
                return _context.abrupt("return", {
                  recentFulfillerIds: settings.recentFulfillerIds || [],
                  recentFulfillerIdsMulti: settings.recentFulfillerIdsMulti || []
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getRecentFulfillerIds() {
        return _getRecentFulfillerIds.apply(this, arguments);
      }

      return getRecentFulfillerIds;
    }()
  }, {
    key: "updateRecentFulfillerIds",
    value: function () {
      var _updateRecentFulfillerIds = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(fulfillerIds) {
        var orderedFulfillerIds, _ref, recentFulfillerIds, recentFulfillerIdsMulti, update;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!this.props.multi && (fulfillerIds.length === 0 || fulfillerIds[0] === this.state.recentFulfillerIds[0]))) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                // Latest fulfiller ID is the most recent
                orderedFulfillerIds = fulfillerIds.slice().reverse(); // initial, strictly visual client-side update to circumvent a wait on GET Customizr

                this.setState({
                  recentFulfillerIds: orderedFulfillerIds.concat((this.state.recentFulfillerIds || []).filter(function (id) {
                    return !fulfillerIds.includes(id);
                  }))
                });
                _context2.next = 6;
                return this.getRecentFulfillerIds();

              case 6:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 9;
                  break;
                }

                _context2.t0 = [];

              case 9:
                _ref = _context2.t0;
                recentFulfillerIds = _ref.recentFulfillerIds;
                recentFulfillerIdsMulti = _ref.recentFulfillerIdsMulti;
                update = {
                  recentFulfillerIds: orderedFulfillerIds.concat(recentFulfillerIds.filter(function (id) {
                    return !fulfillerIds.includes(id);
                  })),
                  recentFulfillerIdsMulti: recentFulfillerIdsMulti
                };
                this.setState(update);

                if (this.props.multi) {
                  update.recentFulfillerIdsMulti = fulfillerIds; // store the last multi-select selection every time
                }

                this.customizrClient.putSettings(this.props.accessToken, update);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateRecentFulfillerIds(_x) {
        return _updateRecentFulfillerIds.apply(this, arguments);
      }

      return updateRecentFulfillerIds;
    }()
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this4 = this;

      var fulfillers = this.state.fulfillers || this.props.fulfillers || [];

      if (!fulfillers) {
        if (this.state.fetchingFulfillers) {
          return [{
            text: this.tt('loading'),
            optionRenderer: this.fulfillerSpinnerOptionRenderer
          }];
        }

        return [{
          text: this.tt('no-data'),
          optionRenderer: this.fulfillerWarningMessageOptionRenderer
        }];
      }

      var filteredFulfillers = this.props.multi ? fulfillers.filter(function (fulfiller) {
        return !_this4.state.selectedFulfillerIds.includes(fulfiller.fulfillerId);
      }) : fulfillers;

      if (this.props.fulfillersFilterFunction) {
        filteredFulfillers = filteredFulfillers.filter(this.props.fulfillersFilterFunction);
      }

      var fulfillerOptions = filteredFulfillers.filter(function (fulfiller) {
        return _this4.props.includeArchived || !fulfiller.archived;
      }).map(function (fulfiller) {
        return {
          fulfiller: fulfiller,
          value: "".concat(fulfiller.fulfillerId, " ").concat(fulfiller.name),
          // 'value' required for search and focus style change functionality
          optionRenderer: _this4.fulfillerSingleOptionRenderer
        };
      });
      var recentFulfillerOptions = this.state.recentFulfillerIds.map(function (id) {
        return fulfillerOptions.find(function (f) {
          return f.fulfiller.fulfillerId === id;
        });
      }).filter(function (f) {
        return f;
      }).slice(0, 5).map(function (f, index) {
        return Object.assign({}, f, {
          value: "recent-".concat(index)
        });
      }); // do not highlight or show in search results

      var recentFulfillersOptionGroupLabelOption = {
        text: this.tt('recent-fulfillers'),
        optionRenderer: this.fulfillerOptionGroupLabelOptionRenderer
      };
      var fulfillersOptionGroupLabelOption = {
        text: this.tt('all-fulfillers'),
        optionRenderer: this.fulfillerOptionGroupLabelOptionRenderer
      };
      var allOptions = [fulfillersOptionGroupLabelOption].concat(_toConsumableArray(fulfillerOptions));

      if (recentFulfillerOptions.length) {
        allOptions = [recentFulfillersOptionGroupLabelOption].concat(_toConsumableArray(recentFulfillerOptions)).concat(allOptions);
      }

      return allOptions;
    }
  }, {
    key: "variableOptionRenderer",
    value: function variableOptionRenderer(options) {
      return options.option.optionRenderer(options);
    }
  }, {
    key: "fulfillerSpinnerOptionRenderer",
    value: function fulfillerSpinnerOptionRenderer(_ref2) {
      var option = _ref2.option,
          key = _ref2.key,
          style = _ref2.style;
      return _react.default.createElement("div", {
        className: "VirtualizedSelectOption VirtualizedSelectDisabledOption",
        style: style,
        key: key
      }, _react.default.createElement("span", {
        className: "FulfillerSelect-vertical-center"
      }, _react.default.createElement(Spinner, {
        className: "FulfillerSelect-Spinner-20",
        size: 20
      }), _react.default.createElement("span", {
        className: "FulfillerSelect-Spinner-text"
      }, option.text)));
    }
  }, {
    key: "fulfillerWarningMessageOptionRenderer",
    value: function fulfillerWarningMessageOptionRenderer(_ref3) {
      var option = _ref3.option,
          key = _ref3.key,
          style = _ref3.style;
      return _react.default.createElement("div", {
        className: "VirtualizedSelectOption VirtualizedSelectDisabledOption",
        style: style,
        key: key
      }, _react.default.createElement("span", null, option.text));
    }
  }, {
    key: "fulfillerOptionGroupLabelOptionRenderer",
    value: function fulfillerOptionGroupLabelOptionRenderer(_ref4) {
      var option = _ref4.option,
          key = _ref4.key,
          style = _ref4.style;
      return _react.default.createElement("div", {
        className: "VirtualizedSelectOption FulfillerSelect-option-group-label",
        style: style,
        key: key
      }, _react.default.createElement("strong", null, option.text));
    }
  }, {
    key: "fulfillerSingleOptionRenderer",
    value: function fulfillerSingleOptionRenderer(_ref5) {
      var focusedOption = _ref5.focusedOption,
          focusOption = _ref5.focusOption,
          key = _ref5.key,
          option = _ref5.option,
          selectValue = _ref5.selectValue,
          style = _ref5.style,
          valueArray = _ref5.valueArray;
      var className = ['VirtualizedSelectOption'];
      var content = this.formatTitle(option.fulfiller) || this.tt('misconfigured');

      if (option.fulfiller.archived) {
        className.push('VirtualizedSelectDisabledOption');
      }

      if (focusedOption && focusedOption.fulfiller && option.fulfiller.fulfillerId === focusedOption.fulfiller.fulfillerId) {
        className.push('VirtualizedSelectFocusedOption');
      }

      if (valueArray && valueArray.find(function (value) {
        return value.fulfillerId === option.fulfiller.fulfillerId;
      })) {
        className.push('VirtualizedSelectSelectedOption');
      }

      var events = {
        onClick: function onClick() {
          return selectValue(option);
        },
        onMouseEnter: function onMouseEnter() {
          return focusOption(option);
        }
      };
      return _react.default.createElement("div", _extends({
        className: className.join(' '),
        key: key,
        title: option.fulfiller.fulfillerId,
        style: style
      }, events), content);
    }
  }, {
    key: "fulfillerValueRenderer",
    value: function fulfillerValueRenderer(option) {
      return this.formatTitle(option.fulfiller) || this.tt('misconfigured');
    }
  }, {
    key: "formatTitle",
    value: function formatTitle(fulfiller) {
      var content = null;

      if (this.props.includeName) {
        if (this.props.includeId && this.props.includeInternalId) {
          content = _react.default.createElement("span", null, fulfiller.name, " (", fulfiller.fulfillerId, " / ", _react.default.createElement("span", {
            className: 'text-muted'
          }, fulfiller.internalFulfillerId), ")");
        } else if (this.props.includeId) {
          content = _react.default.createElement("span", null, fulfiller.name, " (", fulfiller.fulfillerId, ")");
        } else if (this.props.includeInternalId) {
          content = _react.default.createElement("span", null, fulfiller.name, " (", _react.default.createElement("span", {
            className: 'text-muted'
          }, fulfiller.internalFulfillerId), ")");
        } else {
          content = fulfiller.name;
        }
      } else {
        if (this.props.includeId && this.props.includeInternalId) {
          content = _react.default.createElement("span", null, fulfiller.fulfillerId, " / ", _react.default.createElement("span", {
            className: 'text-muted'
          }, fulfiller.internalFulfillerId));
        } else if (this.props.includeId) {
          content = _react.default.createElement("span", null, fulfiller.fulfillerId);
        } else if (this.props.includeInternalId) {
          content = _react.default.createElement("span", {
            className: 'text-muted'
          }, fulfiller.internalFulfillerId);
        }
      }

      return content;
    }
  }, {
    key: "tt",
    value: function tt(key) {
      var _this$props = this.props,
          t = _this$props.t,
          language = _this$props.language;
      return t(key, {
        lng: language
      });
    }
  }, {
    key: "mapFulfillerIdsToFulfillers",
    value: function mapFulfillerIdsToFulfillers(fulfillerIds) {
      var _this5 = this;

      var fulfillers = fulfillerIds.map(function (f) {
        return _this5.fulfillerMap[f];
      });
      return this.props.multi ? fulfillers : fulfillers[0];
    }
  }, {
    key: "mapFulfillerIdsToValues",
    value: function mapFulfillerIdsToValues(fulfillerIds) {
      var _this6 = this;

      var values = fulfillerIds.map(function (fulfillerId) {
        var fulfiller = _this6.fulfillerMap[fulfillerId];
        return {
          fulfiller: fulfiller,
          value: "".concat(fulfiller.fulfillerId, " ").concat(fulfiller.name)
        };
      });
      return this.props.multi ? values : values[0];
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement(_SelectWrapper.default, {
        selectedSelect: _reactVirtualizedSelect.default,
        label: this.props.label || this.tt('label'),
        value: this.mapFulfillerIdsToValues(this.state.selectedFulfillerIds),
        options: this.getOptions(),
        noResultsText: this.tt('no-results-found'),
        clearable: this.props.multi,
        onChange: this.handleChange,
        optionRenderer: this.variableOptionRenderer,
        valueRenderer: this.fulfillerValueRenderer,
        multi: this.props.multi,
        tether: true
      }));
    }
  }]);

  return FulfillerMultiSelect;
}(_react.default.Component);

FulfillerMultiSelect.propTypes = {
  // silence eslint
  t: _propTypes.default.any,
  i18n: _propTypes.default.any,
  // Either access token OR a list of fulfillers to display
  accessToken: _propTypes.default.string,
  fulfillers: _propTypes.default.array,
  fulfillersFilterFunction: _propTypes.default.func,
  selectedFulfillerIds: _propTypes.default.array,
  // functions and buttons
  onChange: _propTypes.default.func,
  // display
  language: _propTypes.default.string,
  label: _propTypes.default.string,
  includeArchived: _propTypes.default.bool,
  includeId: _propTypes.default.bool,
  includeInternalId: _propTypes.default.bool,
  includeName: _propTypes.default.bool,
  autoSelectMostRecent: _propTypes.default.bool,
  multi: _propTypes.default.bool,
  env: _propTypes.default.string
};
FulfillerMultiSelect.defaultProps = {
  language: 'en',
  includeArchived: false,
  includeId: false,
  includeInternalId: false,
  includeName: true,
  autoSelectMostRecent: true,
  multi: true,
  env: _consts.EnvironmentKey.Production
};

var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(FulfillerMultiSelect);

exports.default = _default;